function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_1009_24750",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5V24C18.6274 24 24 18.6274 24 12H19.5ZM12 4.5C16.1421 4.5 19.5 7.85786 19.5 12H24C24 5.37258 18.6274 0 12 0V4.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5V0C5.37258 0 0 5.37258 0 12H4.5ZM12 19.5C7.85786 19.5 4.5 16.1421 4.5 12H0C0 18.6274 5.37258 24 12 24V19.5ZM21.75 12C21.75 17.3848 17.3848 21.75 12 21.75V26.25C19.8701 26.25 26.25 19.8701 26.25 12H21.75ZM12 2.25C17.3848 2.25 21.75 6.61522 21.75 12H26.25C26.25 4.12994 19.8701 -2.25 12 -2.25V2.25ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25V-2.25C4.12994 -2.25 -2.25 4.12994 -2.25 12H2.25ZM12 21.75C6.61522 21.75 2.25 17.3848 2.25 12H-2.25C-2.25 19.8701 4.12994 26.25 12 26.25V21.75Z",
  fill: "#F1EFEE",
  mask: "url(#path-1-inside-1_1009_24750)"
});
var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-2_1009_24750",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5V24C18.6274 24 24 18.6274 24 12H19.5ZM12 4.5C16.1421 4.5 19.5 7.85786 19.5 12H24C24 5.37258 18.6274 0 12 0V4.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5V0C5.37258 0 0 5.37258 0 12H4.5ZM12 19.5C7.85786 19.5 4.5 16.1421 4.5 12H0C0 18.6274 5.37258 24 12 24V19.5ZM21.75 12C21.75 17.3848 17.3848 21.75 12 21.75V26.25C19.8701 26.25 26.25 19.8701 26.25 12H21.75ZM12 2.25C17.3848 2.25 21.75 6.61522 21.75 12H26.25C26.25 4.12994 19.8701 -2.25 12 -2.25V2.25ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25V-2.25C4.12994 -2.25 -2.25 4.12994 -2.25 12H2.25ZM12 21.75C6.61522 21.75 2.25 17.3848 2.25 12H-2.25C-2.25 19.8701 4.12994 26.25 12 26.25V21.75Z",
  fill: "url(#paint0_linear_1009_24750)",
  mask: "url(#path-3-inside-2_1009_24750)"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1009_24750)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 -5.24537e-07C13.5759 -5.9342e-07 15.1363 0.310388 16.5922 0.913446C18.0481 1.5165 19.371 2.40041 20.4853 3.51472C21.5996 4.62902 22.4835 5.95189 23.0866 7.4078C23.6896 8.86371 24 10.4241 24 12C24 13.5759 23.6896 15.1363 23.0866 16.5922C22.4835 18.0481 21.5996 19.371 20.4853 20.4853C19.371 21.5996 18.0481 22.4835 16.5922 23.0866C15.1363 23.6896 13.5759 24 12 24L12 12L12 -5.24537e-07Z",
  fill: "#EC008C"
}));
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1009_24750",
  x1: 24,
  y1: 0.36,
  x2: 10.0022,
  y2: 28.9049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E20074"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B9005F"
})));
function SvgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1009_24750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _ref4, _ref5), _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step-5.2ebd347404723c27bf8791117d5887ce.svg";
export { ForwardRef as ReactComponent };